import { clientApi } from 'api';

export const forgetPassword = (isServer = false) => async ({ email }: { email: string }) => {
  const response = await clientApi.post('/users/forgot-password', { email });

  return response;
};
